export default angular
  .module("CompilerCtrl", ["ui.bootstrap"])
  .controller("CompilerController", [
    "$scope",
    "$modalInstance",
    "$interval",
    "Compiler",
    function ($scope, $modalInstance, $interval, Compiler) {
      $scope.status = {
        isCompiling: false,
        time: 0,
        progress: 0,
        lastCompilationTime: null,
        error: null,
      };

      const setError = (err) => {
        $scope.status.error = {
          status: err.status,
          errorMessage: (err.data && err.data.errorMessage) || err.statusText,
        };
      };

      const setResults = (results) => {
        if (results) {
          $scope.result = {
            elapsedTime: $scope.status.time,
            errors: results.errors,
            files: results.files,
            liveDataStatus: results.liveDataStatus,
          };
        }
      };

      Compiler.status().then(({ data }) => {
        const time = new Date(data.lastSuccessfulCompilation);
        $scope.status.lastCompilationTime = `${time.toLocaleString()}`;
      }).catch(setError);

      let start;

      const stopTimer = () => {
        if (angular.isDefined($scope.Timer)) {
          $interval.cancel($scope.Timer);
        }
        $scope.status.isCompiling = false;
      };

      const getElapsedTimeInSeconds = () => ((new Date().getTime() - start) / 1000).toFixed(1);

      const startTimer = () => {
        start = new Date().getTime();
        $scope.Timer = $interval(() => {
          $scope.status.time = getElapsedTimeInSeconds();
          $scope.status.progress += 1 / $scope.status.time;
        }, 100);
      };

      const handleResult = (result) => {
        stopTimer();
        setResults(result.data);
      };

      const handleError = (err) => {
        setError(err);
        handleResult(err);
      };

      const compile = () => {
        delete $scope.status.error;

        startTimer();
        $scope.status.isCompiling = true;
        Compiler
          .compileAll()
          .then(handleResult)
          .catch(handleError);
      };

      $scope.compile = () => {
        compile();
      };

      $scope.ok = () => {
        $modalInstance.close();
      };
    },
  ]);

angular.module("CompilerCtrl").filter("formatFileSizeDiff", () => (input) => {
  const plusSign = input > 0 ? "+" : "";
  if (input < 1000 && input > -1000) {
    return `${plusSign}${input} B`;
  }
  return `${plusSign}${(input / 1000).toFixed(1)} kB`;
});
